import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const pinIcon = L.divIcon({
  className: '',
  html: `<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;
    background:#FF6B35;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35);
    transform:rotate(-45deg);"></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

const CENTRO_BRASIL = [-14.235, -51.9253];

// Mapa Leaflet com um marcador (posição da loja ou do endereço do cliente) e,
// opcionalmente, um círculo mostrando o raio de entrega em km.
export default function MapaRaioEntrega({
  markerPos, onMarkerChange, radiusKm, height = 320, editable = true,
}) {
  const containerRef = useRef(null);
  const mapRef        = useRef(null);
  const markerRef      = useRef(null);
  const circleRef      = useRef(null);
  const onChangeRef    = useRef(onMarkerChange);
  onChangeRef.current   = onMarkerChange;

  useEffect(() => {
    const map = L.map(containerRef.current, {
      center: markerPos || CENTRO_BRASIL,
      zoom: markerPos ? 15 : 4,
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;

    if (editable) {
      map.on('click', (e) => onChangeRef.current?.(e.latlng.lat, e.latlng.lng));
    }

    return () => { map.remove(); mapRef.current = null; markerRef.current = null; circleRef.current = null; };
  }, [editable]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    if (markerPos) {
      if (!markerRef.current) {
        markerRef.current = L.marker(markerPos, { icon: pinIcon, draggable: editable }).addTo(map);
        markerRef.current.on('dragend', () => {
          const { lat, lng } = markerRef.current.getLatLng();
          onChangeRef.current?.(lat, lng);
        });
        map.setView(markerPos, Math.max(map.getZoom(), 15));
      } else {
        markerRef.current.setLatLng(markerPos);
      }
      markerRef.current.dragging?.[editable ? 'enable' : 'disable']?.();
    } else if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }

    if (radiusKm && markerPos) {
      const meters = radiusKm * 1000;
      if (!circleRef.current) {
        circleRef.current = L.circle(markerPos, {
          radius: meters, color: '#FF6B35', fillColor: '#FF6B35', fillOpacity: 0.12, weight: 2,
        }).addTo(map);
      } else {
        circleRef.current.setLatLng(markerPos);
        circleRef.current.setRadius(meters);
      }
    } else if (circleRef.current) {
      circleRef.current.remove();
      circleRef.current = null;
    }
  }, [markerPos?.[0], markerPos?.[1], radiusKm, editable]);

  return (
    <div ref={containerRef} style={{ height, borderRadius: 14, overflow: 'hidden', border: '1px solid var(--border, #e8e4de)' }} />
  );
}
